module.exports = __webpack_public_path__ + "media/images/silhueta-a3ac9b42c0943b785e57634608e188e2.svg";